import React, { useState } from 'react';
import List from 'components/v2/list/List';
import classNames from 'classnames';
import Pagination from 'components/v2/PaginationV2';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from 'components/v2/LoadingIndicator';
import ContractListItem from './ContractListItem';
export default function Expired({ className, id, loading, data: expiredContracts = [], }) {
    const [page, setPage] = useState(1);
    const { t } = useTranslation();
    function renderExpired() {
        if (expiredContracts.length === 0 && !loading) {
            return React.createElement("p", null, t('NO_EXPIRED_QUICKPAY'));
        }
        return (React.createElement(List, { title: t('EXPIRED') },
            expiredContracts.map((contract, i) => {
                return (React.createElement(ContractListItem, { data: contract, key: i, actionsEnabled: false }));
            }),
            React.createElement(Pagination, { className: "mt-4 border-none", perPage: 5, total: expiredContracts.length, pages: Math.floor(expiredContracts.length / 5), page: page, onPageClick: (selectedPage) => setPage(selectedPage), paginationContainerClassName: "mx-auto my-0 sticky right-2/4" })));
    }
    return loading ? (React.createElement(LoadingIndicator, null)) : (React.createElement("div", { className: classNames('lx:w-1/2 w-full', className) }, renderExpired()));
}
